(function($) {
  $(document).ready(function() {
    const resizeFlipCards = () => {
      $('.teammembers__inner').each(function() {
        let maxHeight = 0;
        $(this).find(".team-card").each(function() {
          const inner = $(this).find(".inner");
          const front = $(this).find(".flip-box-front");
          const back = $(this).find(".flip-box-back");
          const quote = $(this).find(".team-card__quote");
          const quoteHeight = quote.height();

          maxHeight = quoteHeight > maxHeight ? quoteHeight : maxHeight;

        });

        $(this).find(".team-card").each(function() {
          const inner = $(this).find(".inner");
          const front = $(this).find(".flip-box-front");
          const back = $(this).find(".flip-box-back");
          const quote = $(this).find(".team-card__quote");
          const quoteHeight = quote.height();

          inner.css("min-height", maxHeight + 50 + "px");
          front.css("min-height", maxHeight + 50 + "px");
          back.css("min-height", maxHeight + 50 + "px");

        } );
      });
    }

    resizeFlipCards();

    $(window).resize(function() {
      resizeFlipCards();
    });
  });
}(jQuery));